import { Divider, Stack } from '@optimus-web/core';
import { UploadAttachmentSection } from './UploadAttachment/UploadAttachmentSection';
import { AddTemplateSection } from './AddTemplateSection';
import { SelectAttachmentSection } from './SelectAttachment/SelectAttachmentSection';

export const TemplatesStepForm = () => {
    return (
        <Stack vertical spacing="400">
            <AddTemplateSection />
            <Divider />
            <SelectAttachmentSection />
            <Divider />
            <UploadAttachmentSection />
        </Stack>
    );
};
